// extracted by mini-css-extract-plugin
export default {"drawPile":"DrawPile_drawPile__tj3T1"};